<template>
  <!-- 默认弹窗 -->
  <template v-if="type === 'close'">
    <ClosePopup ref="popupRef" v-bind="closePopupProps" @close="close">
      <template #background>
        <slot name="background"></slot>
      </template>
      <template #header>
        <slot name="header"></slot>
      </template>
      <template #content>
        <slot name="content"></slot>
      </template>
    </ClosePopup>
  </template>

  <!-- 全屏弹窗 -->
  <template v-else-if="type === 'fullScreen'">
    <FullScreenPopup ref="popupRef" v-bind="fullScreenPopupProps" @close="close">
      <template #background>
        <slot name="background"></slot>
      </template>
      <template #content>
        <slot name="content"></slot>
      </template>
    </FullScreenPopup>
  </template>

  <!-- 容器弹窗 -->
  <template v-else-if="type === 'container'">
    <ContainerPopup ref="popupRef" v-bind="containerPopupProps" @close="close">
      <template #content>
        <slot name="content"></slot>
      </template>
    </ContainerPopup>
  </template>
</template>

<script setup>
const popupRef = ref(null)

const props = defineProps({
  type: {
    type: String,
    default: 'close',
    validator: (value) => ['close', 'fullScreen', 'container'].includes(value),
  },
  title: { type: String, default: '' },
  position: { type: [Number, String], default: 'center' },
  height: { type: [Number, String], default: 100 },
  closeable: { type: Boolean, default: true },
  closeOnClickOverlay: { type: Boolean, default: false },
  padding: { type: [Number, String], default: 10 },
  radius: { type: [Number, String], default: 15 },
  background: { type: String, default: '' },
  borderSize: { type: [Number, String], default: 1 },
  borderColor: { type: String, default: '' },
  boxShadow: { type: Boolean, default: true },
  overlayStyle: { type: Object, default: null },
})

const closePopupProps = computed(() => {
  const { type, ...rest } = props
  return rest
})

const fullScreenPopupProps = computed(() => {
  const { height, closeOnClickOverlay, closeable, position, overlayStyle } = props
  return { height, closeOnClickOverlay, closeable, position, overlayStyle }
})

const containerPopupProps = computed(() => {
  const {
    type,
    position,
    title,
    closeOnClickOverlay,
    closeable,
    padding,
    radius,
    background,
    borderSize,
    borderColor,
    boxShadow,
    overlayStyle,
  } = props
  return {
    title,
    closeOnClickOverlay,
    closeable,
    padding,
    radius,
    background,
    borderSize,
    borderColor,
    boxShadow,
    overlayStyle,
  }
})

const close = () => {
  emit('close')
}

const emit = defineEmits(['close'])

defineExpose({
  open: () => popupRef.value?.open(),
  close: () => popupRef.value?.close(),
})
</script>
